import { render, staticRenderFns } from "./PopupSuccess.vue?vue&type=template&id=2da591d6"
import script from "./PopupSuccess.vue?vue&type=script&lang=js"
export * from "./PopupSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports